"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import API from "@ym-framework/api-utils";
let ShopVideoOpenTipDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.confirm_text = 5;
    this.show_text = null;
    this.timer = null;
    this.btn_disabled = true;
    this.shop_item = null;
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  open(item) {
    return __async(this, null, function* () {
      try {
        this.shop_item = item;
        this.show_text = `(${this.confirm_text}s)`;
        this.timer = setInterval(() => {
          if (this.confirm_text < 1) {
            this.btn_disabled = false;
            this.show_text = null;
            this.confirm_text = 5;
            clearInterval(this.timer);
            this.timer = null;
          } else {
            this.btn_disabled = true;
            this.confirm_text = this.confirm_text - 1;
            this.show_text = `(${this.confirm_text}s)`;
          }
        }, 1e3);
        this._shopVideoOpenTipDialog.show();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  openShopVideo() {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.auth/api/v8/shops/${this.shop_item.shopOldId}/video-auth`);
        this.closeBtn();
        this.$message.success(this.$t("shopvideoopendialog.tip_content.open_success"));
        this.$emit("refresh");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  closeBtn() {
    this._shopVideoOpenTipDialog.hide();
    this.btn_disabled = true;
  }
};
__decorateClass([
  Ref("shopVideoOpenTipDialog")
], ShopVideoOpenTipDialog.prototype, "_shopVideoOpenTipDialog", 2);
ShopVideoOpenTipDialog = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], ShopVideoOpenTipDialog);
export {
  ShopVideoOpenTipDialog as default
};
